import React from 'react';
import InputMask from 'react-input-mask';
import { SelectPicker } from 'rsuite';


export const MaskedInputPhone = ({ onChange, ...rest }) => {
    return (
      <InputMask
        {...rest}
        className="rs-input"
        mask="(999) 999 9999" 
        maskChar={null}
        onChange={event => {
          onChange(event.target.value);
        }}
      />
    );
  };

  export const MaskedInputYear = ({ onChange, ...rest }) => {
    return (
      <InputMask
        {...rest}
        className="rs-input"
        mask="2099" 
        maskChar={null}
        onChange={event => {
          onChange(event.target.value);
        }}
      />
    );
  };


export const InputSelectorClientes = ({ onChange, ...rest }) => {
    const renderSelect=(value, item) => {
        return (
          <div className="row mr-1 ml-1">
              <div className="col-3 text-success">{item.folio}</div>
              <div className="col-9"><strong>{item.nombre}</strong></div>
          </div>
        );
    }
    
    return (
        <SelectPicker 
            {...rest}
            renderValue={renderSelect}
            renderMenuItem={renderSelect}
            block
        />
    );
}